var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9247 47.3264C26.1706 45.9473 23.1077 43.496 20.7361 39.9726L28.4318 35.2254C28.9793 36.1227 29.6331 36.9209 30.4741 37.6619C31.3152 38.403 32.2439 38.9841 33.2602 39.4054C34.2765 39.8267 35.4429 40.0691 36.6969 40.1516C37.951 40.2341 39.2554 40.0351 40.6289 39.6153C42.2082 39.1327 43.4726 38.5104 44.4035 37.7541C45.1498 36.7288 45.814 35.6497 46.3901 34.5276C46.5242 33.8138 46.4841 33.0912 46.2638 32.3709C45.9288 31.2756 45.3375 30.4583 44.4274 29.938C43.5173 29.4176 42.4572 29.0763 41.1659 28.8721C39.8746 28.6679 38.4147 28.5817 36.8485 28.5946C35.2823 28.6075 33.6351 28.5786 31.9068 28.5079C30.4655 28.4827 28.9869 28.3357 27.4273 28.1469C25.8677 27.9582 24.3958 27.6096 22.9929 27.0403C21.5899 26.471 20.3185 25.6619 19.1785 24.6131C18.0385 23.5642 17.18 22.0966 16.6031 20.2103C16.1006 18.5674 15.9913 16.8709 16.3562 15.1625C16.7211 13.4541 17.4354 11.7721 18.5178 10.1771C19.6001 8.58219 21.0065 7.15433 22.7372 5.89355C24.4678 4.63277 26.4974 3.67985 28.8074 2.97392C30.8207 2.35866 32.8036 2.07037 34.7388 2.05227C29.5228 -0.220078 23.4482 -0.707604 17.5155 1.10543C4.54232 5.07006 -2.83942 18.5343 1.02797 31.1786C4.73704 43.3053 17.4461 50.2737 29.9247 47.3264Z",
    fill: "url(#logo-gradient_svg__logo-gradient_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 22.3744C48.6964 22.2305 48.3853 22.0966 48.0668 21.9726C46.4394 21.3388 44.6805 20.9448 42.8339 20.7107C40.9874 20.4766 39.1595 20.3033 37.4498 20.2935L33.1258 20.2177C31.7469 20.1733 30.4929 20.0908 29.3451 19.9093C28.1973 19.7277 27.2806 19.4091 26.5326 18.9723C25.7847 18.5355 25.2492 17.9007 24.9886 17.0489C24.5978 15.7711 24.8433 14.5649 25.7689 13.3506C26.6945 12.1362 28.125 11.2333 30.1228 10.6227C31.0593 10.3365 32.033 10.1721 33.0439 10.1293C34.0548 10.0865 35.0591 10.2453 35.9758 10.564C36.8925 10.8827 37.7839 11.3421 38.5878 11.9615C39.3916 12.5808 40.1078 13.3599 40.6739 14.318L41.1733 14.1654L45.5713 11.4111C46.5891 13.0692 47.4141 14.8791 48.0081 16.8214C48.5722 18.6656 48.897 20.5273 49 22.3744Z",
    fill: "url(#logo-gradient_svg__logo-gradient_svg__paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-gradient_svg__logo-gradient_svg__paint0_linear",
    x1: 14,
    y1: 0.00000108712,
    x2: 34.5,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1047FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#E051B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0771F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-gradient_svg__logo-gradient_svg__paint1_linear",
    x1: 14,
    y1: 0.00000108712,
    x2: 34.5,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1047FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#E051B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0771F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGradient);
export default __webpack_public_path__ + "static/media/logo-gradient.4733a0032456f42373b3eb3a0ba558db.svg";
export { ForwardRef as ReactComponent };